<ppl-dialog
  title="Backup Codes"
  i18n-title="@@Backup_Codes"
  width="350px"
  actionLabel="Create new codes"
  i18n-actionLabel="@@Create_new_codes"
  [loading]="(loading$ | async) || (generating$ | async)"
  (action)="onCreateNewCodes()"
  (cancel)="onCancel()">
  <div class="content">
    <div class="title">
      @if (!(loading$ | async)) {
        <ng-container i18n="@@TwoFactorBackupCodesDialogRemainingCodes">{backupCodesRemainingCount$ | async, plural, =0 {No backup codes} =1 {1 backup code remaining} other {{{ backupCodesRemainingCount$ | async }} backup codes remaining}}</ng-container>
      } @else {
        ...
      }
    </div>
    <div class="codes">
      @for (backupCodePair of backupCodesByPairs$ | async; track backupCodePair) {
        <div class="backup-code-pair">
          @for (backupCode of backupCodePair; track backupCode) {
            <div class="backup-code">
              @if (backupCode) {
                {{ backupCode }}
              } @else {
                ... ...
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</ppl-dialog>
